@if (isHeaderAllowed) {
  <ion-header #appHeader>
    <ion-toolbar style="--background: var(--ion-color-toolbar-primary);" mode="md">
      @if (backUrl) {
        <ion-buttons slot="start" style="padding-inline-start: 4px">
          @if (showBackButton) {
            <oe-flat-button [link]="{ text: backUrl}" color="light">
              <ion-icon [ngStyle]="{'color': 'var(--ion-menu-color)'}" name="arrow-back-outline"></ion-icon>
            </oe-flat-button>
          }
        </ion-buttons>
      }
      @if (enableSideMenu && navigationService.position() !== 'left') {
        <ion-buttons slot="start" style="padding-inline-start: 4px">
          <ion-button (keydown.enter)="toggleMenu()" (click)="toggleMenu()" class="custom-menu-button">
            <ion-icon slot="icon-only" name="menu"></ion-icon>
          </ion-button>
          <!-- <ion-menu-button class="cu stom-menu-button"></ion-menu-button> -->
        </ion-buttons>
      }
      <!-- page title is shown if the current page isn't Live nor History -->
      @if ((currentPage !== 'IndexLive' && currentPage !== 'IndexHistory')) {
        <ion-title class="ion-hide-md-up" slot="start"
          [ngStyle]="(backUrl || enableSideMenu) ?
            {'padding-inline-start': '4px', 'color': 'var(--ion-title-color)'} : {'color': 'var(--ion-title-color)'}">
          @if (environment.headerLogo) {
            <img [src]="environment.headerLogo" [alt]="service.currentPageTitle"
              style="height: 32px; width: auto; object-fit: contain; vertical-align: middle;">
          }
          @if (environment.headerTitleShow !== false) {
            @if (environment.headerTitleHtml) {
              <span [innerHTML]="environment.headerTitleHtml"></span>
            } @else {
              {{ service.currentPageTitle }}
            }
          }
        </ion-title>
      }
      <!-- page title is hidden when 'smartphone resolution' is reached -->
      <ion-title class="ion-hide-md-down" slot="start"
         [ngStyle]="(backUrl || enableSideMenu) ?
            {'padding-inline-start': '4px', 'color': 'var(--ion-title-color)'} : {'color': 'var(--ion-title-color)'}">
        @if (environment.headerLogo) {
          <img [src]="environment.headerLogo" [alt]="service.currentPageTitle"
            style="height: 32px; width: auto; object-fit: contain; vertical-align: middle;">
        }
        @if (environment.headerTitleShow !== false) {
          @if (environment.headerTitleHtml) {
            <span [innerHTML]="environment.headerTitleHtml"></span>
          } @else {
            {{ service.currentPageTitle }}
          }
        }
      </ion-title>
      @if (service.currentEdge(); as edge) {
        @if ((currentPage === 'IndexLive' || currentPage === 'IndexHistory') && navigationService.position() !== null &&
        navigationService.position() === 'disabled') {
          <ion-segment mode="md" (ionChange)="segmentChanged($event)" [(ngModel)]="currentPage"
            class="ion-justify-content-center">
            <ion-segment-button tabindex="0" class="focus-visible"
              style="--indicator-color: var(--ion-segment-button-color);--color: var(--ion-color-primary); color: var(--ion-color-primary); min-width: fit-content"
              value="IndexLive">
              <ion-label style="color: var(--ion-color-header-contrast);" class="oe-ci-font-family-bold">
                {{"GENERAL.LIVE" | translate}}
              </ion-label>
            </ion-segment-button>
            <ion-segment-button
              style="--indicator-color: var(--ion-segment-button-color);--color: var(--ion-color-primary); color: var(--ion-text-color);min-width: fit-content"
              value="IndexHistory">
              <ion-label style="color: var(--ion-color-header-contrast);" class="oe-ci-font-family-bold">
                {{"GENERAL.HISTORY" | translate}}
              </ion-label>
            </ion-segment-button>
          </ion-segment>
        }
      }
      <!-- this title tag is for spacing purpose only -->
      <ion-title class="ion-hide-md-down" slot="end">
      </ion-title>
      <ion-buttons slot="end" class="ion-padding-end">
        @if (currentPage === 'IndexLive' || currentPage === 'IndexHistory' || currentPage === 'EdgeSettings') {
          <oe-system-status></oe-system-status>
        }
        @if (service.currentEdge(); as edge) {
          @if (environment.debugMode && edge.roleIsAtLeast('owner')) {
            <ion-button (click)="isSystemLogEnabled = !isSystemLogEnabled">
              <ion-icon [ngStyle]="{'color': 'var(--ion-menu-color)'}" name="bug-outline"></ion-icon>
            </ion-button>
          }
        }
      </ion-buttons>
    </ion-toolbar>
    @if (currentPage === 'IndexHistory' && navigationService.position() !== 'left') {
      <ion-toolbar color="secondary">
        <ion-buttons class="ion-justify-content-center">
          <pickdate></pickdate>
        </ion-buttons>
      </ion-toolbar>
    }
  </ion-header>
}
